// extracted by mini-css-extract-plugin
module.exports = {"section":"MediaFeedItem_section__DIZ3o","relatedMediaPostsSection":"MediaFeedItem_relatedMediaPostsSection__mCAVN"};